import LineController from "./line_controller"
import {addComma, toNumber} from "../utils/utils";

export default class extends LineController {
    static targets = ['code', 'name', 'price', 'cost', 'unit', 'number', 'quantity', 'amount', 'taxType', 'addLine', 'delete', 'destroy']

    calculateAmount(e) {
        // 売価ではなく、原価で計算する
        const targetId = e.target.id
        // const price = toNumber(this.priceTarget.value)
        const cost = toNumber(this.costTarget.value)
        const unit = toNumber(this.unitTarget.value)
        const number = toNumber(this.numberTarget.value)
        if (unit && number && targetId !== this.quantityTarget.id) {
            this.quantityTarget.value = addComma(unit * number)
        }

        const quantity = toNumber(this.quantityTarget.value)
        if (targetId !== this.amountTarget.id) {
            this.amountTarget.value = addComma(Math.floor(cost * quantity))
        }
        $(this.amountTarget).forceChange()

    }

}
